import { MapEntry } from "@mapmycustomers/shared/types/map";
import { convertRegionToLatLngBounds } from "@mapmycustomers/shared/util/geo/GeoService";

import isValidMapEntry from "@app/util/map/isValidMapEntry";

const getMapEntriesBounds = (entries: MapEntry[]): google.maps.LatLngBounds => {
  const bounds = new google.maps.LatLngBounds();

  entries.filter(isValidMapEntry).forEach((entry) => {
    const entryBounds = convertRegionToLatLngBounds(entry.region!);
    bounds.extend(entryBounds.getSouthWest());
    bounds.extend(entryBounds.getNorthEast());
  });

  return bounds;
};

export default getMapEntriesBounds;
